import script from "./SignatureInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureInput.vue?vue&type=script&setup=true&lang=js"

import "./SignatureInput.vue?vue&type=style&index=0&id=76405e86&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76405e86"]])

export default __exports__